import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Boxes, Package, ClipboardList, Inbox } from "lucide-react";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {}); }, []);

  const cards = [
    { label: "Solutions", value: stats?.solutions ?? "—", icon: Boxes, to: "/admin/solutions", color: "bg-msr-blue" },
    { label: "Products", value: stats?.products ?? "—", icon: Package, to: "/admin/products", color: "bg-msr-green" },
    { label: "Orders", value: stats?.orders ?? "—", icon: ClipboardList, to: "/admin/orders", color: "bg-msr-blue" },
    { label: "Leads / RFQ", value: stats?.leads ?? "—", icon: Inbox, to: "/admin/leads", color: "bg-msr-green" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="overline mb-2">Admin Console</div>
      <h1 className="font-heading font-extrabold text-3xl lg:text-4xl tracking-tight">Dashboard</h1>
      <p className="text-msr-slate mt-2">Welcome back. Here's what's happening at MSR.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {cards.map(({ label, value, icon: Icon, to, color }) => (
          <Link key={label} to={to} className="bg-white border border-msr-line p-6 hover:shadow-md transition-shadow relative" data-testid={`admin-stat-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <div className={`h-10 w-10 grid place-items-center text-white ${color}`}>
              <Icon size={18} />
            </div>
            <div className="font-heading font-extrabold text-3xl mt-4 text-msr-ink">{value}</div>
            <div className="text-xs uppercase tracking-wider text-msr-slate mt-1">{label}</div>
          </Link>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-4 mt-6">
        <div className="bg-white border border-msr-line p-6">
          <div className="overline mb-2">Pending orders</div>
          <div className="font-heading font-extrabold text-3xl text-msr-blue">{stats?.pending_orders ?? 0}</div>
          <Link to="/admin/orders" className="text-xs uppercase tracking-wider text-msr-slate hover:text-msr-blue mt-3 inline-block" data-testid="admin-go-orders">Go to orders →</Link>
        </div>
        <div className="bg-white border border-msr-line p-6">
          <div className="overline mb-2">New leads</div>
          <div className="font-heading font-extrabold text-3xl text-msr-green-dark">{stats?.new_leads ?? 0}</div>
          <Link to="/admin/leads" className="text-xs uppercase tracking-wider text-msr-slate hover:text-msr-blue mt-3 inline-block" data-testid="admin-go-leads">Go to leads →</Link>
        </div>
      </div>
    </div>
  );
}
